import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
//import cartSliceReducer from "./slices/cartSlice";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import attendanceListSlice from "./slices/attendanceListSlice";
import userSelfSlice from "./slices/userSelfSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    // cart: cartSliceReducer,
    auth: authSlice,
    users: userSlice,
    usersSelf: userSelfSlice,
    attendances: attendanceListSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
